import { Navigate } from "react-router-dom";
import { StateView } from "../components/StateView";
import { useAuth } from "../contexts/AuthContext";
import { isDevEnvironment } from "../lib/auth";

export function LoginPage() {
  const { identity, loading, error, login, loginAnonymously, retry } = useAuth();
  if (identity) return <Navigate to="/" replace />;
  return (
    <StateView
      eyebrow="Owner workspace"
      title="Your shop, in full view."
      action={
        <>
          <button className="primary-button" onClick={() => void login()} disabled={loading}>
            {loading ? "Connecting…" : "Continue with Internet Identity"}
          </button>
          {isDevEnvironment() ? (
            <button
              className="secondary-button"
              onClick={loginAnonymously}
              disabled={loading}
              type="button"
            >
              Login anonymously (Dev)
            </button>
          ) : null}
          {error ? (
            <button className="text-button" onClick={() => void retry()} type="button">
              Retry session check
            </button>
          ) : null}
        </>
      }
    >
      <p>Sales, margins, products, staff, customers and expenses—separate from the till.</p>
      {error ? <p className="error-copy">{error}</p> : null}
    </StateView>
  );
}
